import { ApprovalConsiderationAnnounceEightComponent } from "../../../components/SupportSystem/ReportOnApprovalConsiderationResults/ApprovalConsiderationAnnounceEightComponent";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
export function ApprovalConsiderationAnnounceEightContainer() {
    const titleName = "รายงานผลการพิจารณาอนุมัติการให้เงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน (แบบ ชอ. 4-4)"; //ใส่ชื่อtitle ตรงนี้
    return (
        <div className="page-container bg-landing">
            {/* <NavbarSupportSystem /> */}
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <ApprovalConsiderationAnnounceEightComponent />
            <Footer />
        </div>
    )
}